import { render } from "./UsersForRoleView.vue?vue&type=template&id=fdf62830&scoped=true&ts=true"
import script from "./UsersForRoleView.vue?vue&type=script&lang=ts"
export * from "./UsersForRoleView.vue?vue&type=script&lang=ts"

import "./UsersForRoleView.vue?vue&type=style&index=0&id=fdf62830&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdf62830"]])

export default __exports__